import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Company, Office, RandstadCompany } from '../models/office.model';
import { AppConfig } from '../helpers/app.config';

@Injectable({
  providedIn: 'root'
})
export class CompanyService {

  constructor(private httpClient: HttpClient) { }

  index(clientId = 1): Observable<Company[]> {
    return this.httpClient.get<RandstadCompany[]>(AppConfig.settings.API + '/offices', { params: { clientId } }).pipe(
      map(companies => this.groupOfficesByCompany(companies))
    );
  }

  groupOfficesByCompany(companies: RandstadCompany[]): Company[] {
    const groupedCompanies: Company[] = [];
    for (const company of companies) {
      const groupedCompany = {
        id: company.companyId,
        boCompanyId: company.boCompanyId,
        fiscalName: company.fiscalName,
        offices: [],
      } as Company;

      for (const region of company.regions) {
        for (const district of region.districts) {
          for (const branch of district.branches) {
            const office = new Office();
            office.id = branch.id;
            office.randstadOffice = Number(branch.branchId);
            office.companyId = company.companyId;
            office.regionId = region.regionId;
            office.districtId = district.districtId;
            office.name = branch.name;
            office.selectName = branch.branchId.padStart(4, '0') + ' ' + branch.name.toLowerCase();
            groupedCompany.offices.push(office);
          }
        }
      }

      if (groupedCompany.offices.length > 0) {
        groupedCompany.offices = groupedCompany.offices.sort((a, b) => a.name.localeCompare(b.name));
        groupedCompanies.push(groupedCompany);
      }
    }
    return groupedCompanies.sort((a, b) => a.fiscalName.localeCompare(b.fiscalName));
  }

}
